import React from 'react';

// AN IMPLEMENTATION'S STATUS AND VERSION PICKERS — one copy, used by a template's Implementations tab
// (IntegrationForm) and by the single implementation page (pipelines/PipelineImplementationPage). The caller does the
// save (and, for a version, the confirmation); these only draw the choice.

// Draft / active / paused. Draft is the normal state of something half-configured, so it is not coloured like a fault.
// Active needs every slot filled: the proxy would otherwise route with the template's own (usually empty) credentials
// for the missing ones.
export function ImplementationStatusSelect({ impl, disabled, onChange }) {
  const empty = (impl.slots || 0) - (impl.filled || 0);
  return (
    <select
      className={`ifm-impl-status status-badge ${impl.status === 'active' ? 'status-active' : 'status-pending'}`}
      value={impl.status}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value)}
      aria-label={`Status of ${impl.name}`}
    >
      <option value="draft">draft</option>
      <option value="active" disabled={empty > 0}>
        {empty > 0 ? `active (${empty} slot(s) empty)` : 'active'}
      </option>
      <option value="paused">paused</option>
    </select>
  );
}

// THE VERSION THIS PROPERTY ROUTES WITH (V672). Making a version live moves nobody already on one, so each property is
// moved here — and the hint says when it is behind the live one. "draft" only for a template never published: it
// routes the draft.
export function ImplementationVersionSelect({ impl, versions, liveVersionId, disabled, onChange }) {
  if (!(versions || []).length) return <span className="form-help" style={{ margin: 0 }}>draft</span>;
  const current = impl.version_id || liveVersionId || '';
  return (
    <>
      <select
        className="ifm-impl-status status-badge status-pending"
        value={current}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        aria-label={`Version ${impl.name} routes with`}
      >
        {!current && <option value="">no version</option>}
        {versions.map(v => (
          <option key={v.id} value={v.id}>
            v{v.version}{String(v.id) === String(liveVersionId) ? ' (live)' : ''}
          </option>
        ))}
      </select>
      {impl.version && impl.live_version && impl.version !== impl.live_version && (
        <div className="form-help" style={{ margin: '0.2rem 0 0' }}>v{impl.live_version} is live</div>
      )}
    </>
  );
}
